import React, { useState } from "react"
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Tbody,
  Tr,
  Td,
  Thead,
  Th,
  useDisclosure,
} from "@chakra-ui/react"
import { AccountService } from "../api" // Adjust the import path as necessary
import { formatPublicKey } from "../utils"

export const HomePage: React.FC = () => {
  const [identifier, setIdentifier] = useState("")
  const [publicKey, setPublicKey] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleCreateWallet = async () => {
    setLoading(true)
    console.log("Creating wallet with identifier:", identifier)
    try {
      const { publicKey: newPublicKey } = await AccountService.createKeypair(identifier)
      console.log("Wallet created. Public Key:", newPublicKey)
      setPublicKey(newPublicKey)
      onOpen() // Open the modal after successful creation
    } catch (err) {
      console.error("Error creating wallet:", (err as Error).message)
      setPublicKey(null) // Clear publicKey on error
      onOpen() // Open the modal even on error to show the message
    } finally {
      setLoading(false)
      console.log("Wallet creation process finished.")
    }
  }

  // Function to copy public key to clipboard
  const copyToClipboard = async () => {
    if (publicKey) {
      await navigator.clipboard.writeText(publicKey)
      alert("Public key copied to clipboard!") // Notify the user
    }
  }

  return (
    <Box p={5}>
      <Text fontSize="2xl" mb={4}>
        Create Solana Wallet
      </Text>
      <FormControl isRequired>
        <FormLabel htmlFor="identifier">Identifier</FormLabel>
        <Input id="identifier" placeholder="Enter identifier" value={identifier} onChange={e => setIdentifier(e.target.value)} />
      </FormControl>
      <Button mt={4} colorScheme="teal" onClick={handleCreateWallet} isLoading={loading}>
        Create Wallet
      </Button>

      {/* Modal to display the result */}
      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent maxW="600px">
          <ModalHeader>{publicKey ? "Wallet Created" : "Error"}</ModalHeader>
          <ModalBody>
            {publicKey ? (
              <Box overflowX="auto">
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th>Identifier</Th>
                      <Th>Public Key</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>{identifier}</Td>
                      <Td>
                        {formatPublicKey(publicKey)}
                        <Button ml={2} onClick={copyToClipboard} size="sm" colorScheme="teal">
                          Copy
                        </Button>
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </Box>
            ) : (
              <Text>Error creating wallet. Please try again.</Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )
}
